import { AppTextService } from '@fi-shared/app-text';
import { createMap } from '@fi-shared/utils/create-map';

export enum fiPackageType {
    Free = 1,
    Small = 2,
    Medium = 3,
    Large = 4,
    ExtraLarge = 5,
    XXL = 6,
}

export const fiPackageTypes = [
    {
        id: fiPackageType.Free,
        textId: 'package_type.free',
    },
    {
        id: fiPackageType.Small,
        textId: 'common.small',
    },
    {
        id: fiPackageType.Medium,
        textId: 'common.medium',
    },
    {
        id: fiPackageType.Large,
        textId: 'common.large',
    },
    {
        id: fiPackageType.ExtraLarge,
        textId: 'package_type.extra_large',
    },
    {
        id: fiPackageType.XXL,
        textId: 'package_type.xxl',
    },
];

const fiPackageTypesMap = createMap(fiPackageTypes, 'id');
export function fiPackageTypeName(packageType: fiPackageType, appText: AppTextService) {
    if (fiPackageTypesMap.hasOwnProperty(packageType)) return appText.get(fiPackageTypesMap[packageType].textId);

    throw 'FI: unknown package type ' + packageType;
}
